export const CART_ACTION_TYPES = {
  SET_CART_ITEMS: "SET_CART_ITEMS",
  TOGGLE_DROPDOWN: "TOGGLE_DROPDOWN",
}
